import { useState, useEffect } from 'react';
import './App.scss';
import { Home } from "./pages/home/home";
import { PrivacyPolicy } from "./pages/privacy-policy/privacy-policy";

function App() {
  const [hash, setHash] = useState(window.location.hash);

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    if (hash && hash !== '#/privacy-policy') {
      const id = hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [hash]);

  if (hash === '#/privacy-policy') {
    return <PrivacyPolicy />;
  }

  return <Home />;
}

export default App;
